import React, { useState, useEffect } from "react";
import axios from "axios";
import API_ENDPOINTS from '../../utils/apiEndpoints';

const UpdateProfile = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [responseMessage, setResponseMessage] = useState(null);
    const [errorData, setErrorData] = useState(null);
    const [updatedUser, setUpdatedUser] = useState(null);

    const token = localStorage.getItem("adminToken");
    // const token = "60|axvXzLrrTqCOmArof8qZNHOhSVf0ZzdqO3hZN6u93740398f"

    const handleUpdateProfile = async () => {
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_PROFILE_UPDATE,
                { name, email },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setResponseMessage(response.data.message);
            setUpdatedUser(response.data.user);
            setErrorData(null);
            setEmail("");
            setName("");
        } catch (error) {
            if (error.response && error.response.data) {
                setResponseMessage(error.response.data.message);
                setErrorData(error.response.data.data || null);
            } else {
                setResponseMessage("An error occurred. Please try again.");
            }
        }
    };

    return (
        <div className="w-screen min-h-screen flex items-center justify-center bg-gray-50 px-4 sm:px-6 lg:px-8">
            <div className="relative py-3 sm:max-w-xs sm:mx-auto">
                <div className="min-h-96 px-8 py-6 mt-4 text-left bg-white rounded-xl shadow-lg">
                    <h2 className="text-center font-semibold text-lg">Update Profile</h2>

                    {responseMessage && <p className="text-center text-blue-500 mt-2">{responseMessage}</p>}
                    {errorData && (
                        <div className="text-red-500 text-xs mt-2">
                            {Object.entries(errorData).map(([field, errors]) => (
                                <p key={field}>{errors[0]}</p>
                            ))}
                        </div>
                    )}

                    <div className="w-full flex flex-col gap-2 mt-4">
                        <label className="font-semibold text-xs text-gray-400">Name</label>
                        <input
                            className="border rounded-lg px-3 py-2 mb-3 text-sm w-full outline-none"
                            type="text"
                            placeholder="Enter Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />

                        <label className="font-semibold text-xs text-gray-400">Email</label>
                        <input
                            className="border rounded-lg px-3 py-2 mb-3 text-sm w-full outline-none"
                            type="email"
                            placeholder="Enter Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        <button
                            onClick={handleUpdateProfile}
                            className="py-1 px-8 bg-blue-500 hover:bg-blue-800 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md rounded-lg cursor-pointer"
                        >
                            Update Profile
                        </button>

                        {updatedUser && (
                            <div className="mt-4 p-3 bg-gray-100 rounded-lg text-sm">
                                <p><strong>Updated Name:</strong> {updatedUser.name}</p>
                                <p><strong>Updated Email:</strong> {updatedUser.email}</p>
                                <p><strong>Role:</strong> {updatedUser.role}</p>
                            </div>
                        )}

                        {responseMessage && (
                            <button
                                onClick={() => window.history.back()}
                                className="mt-4 py-1 px-8 bg-gray-500 hover:bg-gray-700 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md rounded-lg cursor-pointer"
                            >
                                Go Back
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateProfile;
